export default __webpack_public_path__ + "static/media/phone_preview.10e980ab.png";